// extracted by mini-css-extract-plugin
export default {"SetupApiLogs-container":"SetupApiLogs-container4ZWF0Vy21g2S","SetupApiLogs-view-demo":"SetupApiLogs-view-demo3BQsFI6b_JB2"};